import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppRest } from './rest';

import {
  RestQuery, QueryParams, PageData
} from '../restquery/restquery';

import { BaseEntity, ID } from '../model/baseentity';
import { map, tap } from 'rxjs/operators';
import { AppConfig, TableDef, APP_CONFIG } from '../meta/appconfig';
import { QueryBuilder } from '../restquery/querybuilder';
import { MetadataDao } from './metadatadao';
import { CacheService } from './cacheservice';
import { LocalQuery } from '../restquery/localquery';

/**
 * åºç¨ç¨åºDao,æä¾å®ä½åå°è®¿é®çæå¡,
 * æä¾äºç¼å­æ¯æï¼TableDef.cachable å¯ä»¥è®¾å®è¯¥å®ä½æ¯å¦è¿è¡ç¼å­
 * @export
 */
@Injectable()
export class AppDao {
  constructor(public appRest: AppRest, public metadataDao: MetadataDao,
    public cacheService: CacheService,
    @Inject(APP_CONFIG) public appConfig: AppConfig) {
    console.log('init appDao...');
  }
  /**
   * è®¾ç½®APPConfigï¼ä¸è¬æåµä¸ï¼AppConfig ä¼èªå¨æ³¨å¥
   * å¨æäºæåµä¸ï¼éè¦è¿è¡æ¶å¨æä¿®æ¹APPConfigï¼å¯ä»¥æ¡ç¨æ¬æ¹æ³
   * @param appConfig
   */
  init(appConfig: AppConfig) {
    this.appConfig = appConfig;
    this.appRest.init(appConfig);
  }

  /**
   * è·åå®ä½çURL
   * @param entName å®ä½åç§°
   */
  getEntityUrl(entName: string) {
    return this.appConfig.getEntity(entName as string).url;
  }
  private getEntityDef(entName: string): TableDef {
    return this.appConfig.getEntity(entName as string);
  }



  /**
   * è·åå®ä½URL,<baseUrl>
   * å¦ææå®äºå®ä½å¯¹è±¡æèIDï¼è¿åï¼&lt;baseUrl&gt;/&lt;id&gt;,
   * å¦ææå®äºæä½ï¼è¿åï¼&lt;baseUrl&gt;/&lt;id&gt;/&lt;op&gt;
   * @param entityName å®ä½åç§°
   * @param obj å®ä½å¯¹è±¡æèID
   * @param op å®ä½æä½
   */
  getUrl(entityName: string, obj?: BaseEntity | ID, op?: string): string {
    const tbl: TableDef = this.getEntityDef(entityName);
    let id = obj;
    if (id) {
      if (typeof obj === 'object') {
        const idFld = tbl.idProp || 'id';
        id = obj[idFld];
      }
    }
    return tbl.url + (id == null ? '' : '/' + id) + (op ? '/' + op : '');
  }

  // /**
  //  * å¯¹æå®URLæ§è¡æ¥è¯¢
  //  * @param url æå®URL
  //  * @param queryInfo Restæ¥è¯¢åæ°
  //  * @returns PageData
  //  */
  // getQueryByUrl(url: string, queryInfo?: RestQuery): Observable<PageData<any>> {
  //   const qb = new QueryBuilder();
  //   qb.addQueryInfo(queryInfo);

  //   return this.appRest.get(url, qb.getQueryInfo());
  // }

  /**
   * æç§IDè·åå®ä½,å¯¹åºåå°GET/IDçAPIï¼
   * @template T å®ä½ç±»å
   * @param string entityName å®ä½åç§°
   * @param ID id å®ä½IDï¼'-1'è¡¨ç¤ºè·åä¸ä¸ªæ°å¢æªå­çå®ä½
   * @param params éå åæ°ï¼é®å¼å¯¹
   * @returns Observable<T> å®ä½å¯¹è±¡
   * @memberOf AppDao
   */
  get<T extends BaseEntity>(entityName: string, id: ID,params?: object): Observable<T> {
    const tbl: TableDef = this.getEntityDef(entityName);
    return this.appRest.getById(tbl.url, id,params) as Observable<T>;
  }


  /**
   * å®ä½æ¥è¯¢,ææå¯¹LISTçæ¥è¯¢æç»é½å¨è¿éå®ç°
   * @param entityName å®ä½åç§°
   * @param params
   * @returns PageData
   */
  getQuery<T extends BaseEntity>(entityName: string, params: RestQuery): Observable<PageData<T>> {
    const tbl: TableDef = this.getEntityDef(entityName);
    const qb = new QueryBuilder();
    qb.addQueryInfo(params);
    if (!qb.sort && !qb.orderBy) {
      if (tbl.sortProp) {
        qb.addSort(tbl.sortProp);
      } else {
        qb.addSort(tbl.idProp || 'id', 'desc');
      }
    }

    if (tbl.filter) {
      for (const key in tbl.filter) {
        if (key) {
          qb.addParam(key, tbl.filter[key]);
        }
      }
    }

    let q = qb.getQueryInfo();
    if (!tbl.cachable || !LocalQuery.localApplyable(q)) {
      return this.appRest.get(tbl.url, q);
    }

    let d$ = this.cacheService.hasEntity(entityName)
      ? of(this.cacheService.getEntity(entityName))
      : this.appRest.get(tbl.url, { first: 0, rows: 0 }).pipe(
        tap((data: PageData<any>) => this.cacheService.addEntity(entityName, data.datas)),
        map((data: PageData<any>) => data.datas)
      )

    return d$.pipe(
      map(datas => LocalQuery.localApplyQuery(datas, q))
    );
  }

  /**
   * å®ä½æ¥è¯¢,åæ°æMapææï¼å°ä¼éæ°è§£æä¸ºRestQueryè¿è¡æ¥è¯¢,ç¸égetQueryçå¿«éç
   * @param entityName å®ä½åç§°
   * @param params æ¥è¯¢åæ°,ä»¥ä¸é®å¼å°è¢«è§£æä¸ºç¹å®åæ°ï¼å¶ä½é®å¼å°å½åæ¥è¯¢æ¡ä»¶:<br>
   *  first: åé¡µæ¥è¯¢æå®çå¼å§ä½ç½®<br>
   *  rows: åé¡µæ¥è¯¢æ¯é¡µçå¤§å°ï¼å¦æå°äºç­äº0ï¼è¡¨ç¤ºä¸åé¡µ<br>
   *  orderBy: æåºå±æ§ï¼å¦ deptName ascï¼deptName descç­ç­ãå¤ä¸ªäººæåºéè¿éå·è¿è¡åé<br>
   *  sort: æåºè®¾ç½®æ°ç»<br>
   *  limit: éåé¡µæ¥è¯¢ä¸­ï¼è¿åæ°éçéå¶<br>
   *  aggregate: å¯¹æ»¡è¶³æ¡ä»¶çæ°æ®è¿è¡èåç»è®¡<br>
   *  columns: æ¥è¯¢æèç»è®¡çå
   * @see RestQuery
   * @returns PageData
   */
  getEntity<T extends BaseEntity>(entityName: string,
    params?: { [prop: string]: any }): Observable<PageData<T>> {
    const pm: RestQuery = { first: 0, rows: 0, search: {} };
    if (params) {
      for (const key in params) {
        if (key === 'first') {
          pm.first = params[key];
        } else if (key === 'rows') {
          pm.rows = params[key];
        } else if (key === 'orderBy') {
          pm.orderBy = params[key];
        } else if (key === 'sort') {
          pm.sort = params[key];
        } else if (key === 'limit') {
          pm.limit = params[key];
        } else if (key === 'aggregate') {
          pm.aggregate = params[key];
        } else if (key === 'columns') {
          pm.columns = params[key];
        } else {
          pm.search[key] = params[key];
        }
      }
    }
    return this.getQuery(entityName, pm);
  }

  /**
   * æç§æå®æ¡ä»¶æ¥è¯¢å®ä½åè¡¨
   * å¯æå®æå¤§çè¿åè¡æ°
   * @template T å®ä½ç±»å
   * @param string entityName å®ä½åç§°
   * @param QueryPrams} [params] æ¥è¯¢åæ°
   * @param number [limit] è¿åè¡æ°éå¶
   * @returns Observable<T[]> å®ä½åè¡¨
   * @memberOf AppDao
   */
  getList<T extends BaseEntity>(entityName: string, params?: QueryParams, limit?: number): Observable<T[]> {
    const pm: RestQuery = { first: 0, rows: 0, search: params };
    if (limit > 0) {
      pm.limit = limit;
    }
    return this.getQuery(entityName, pm).pipe(
      map((r: PageData<any>) => r.datas)
    );
  }

  /**
   * å®ä½åé¡µæ¥è¯¢
   * @template T å®ä½ç±»å
   * @param string entityName å®ä½åç§°
   * @param number first åé¡µèµ·ç¹
   * @param number rows åé¡µé¡µé¿
   * @param QueryParams params æ¥è¯¢åæ°
   * @returns Observable<PageData<T>> åé¡µç»æ
   * @memberOf AppDao
   */
  getPage<T extends BaseEntity>(entityName: string, first: number, rows: number, params?: QueryParams): Observable<PageData<T>> {
    const pm: RestQuery = { first, rows, search: params };
    return this.getQuery(entityName, pm);
  }

  /**
   * ä¿å­å®ä½å°åå°
   * @template T å®ä½ç±»å
   * @param string entityName å®ä½åç§°
   * @param T obj å®ä½å¯¹è±¡
   * @returns Observable<T> ä¿å­åçå®ä½å¯¹è±¡
   * @memberOf AppDao
   */
  save<T extends BaseEntity>(entityName: string, obj: T): Observable<T> {
    const tbl: TableDef = this.getEntityDef(entityName);
    const idFld = tbl.idProp || 'id';
    const id = obj[idFld];
    const url = tbl.url + (id ? '/' + id : '');
    return this.appRest.post(url, obj).pipe(
      tap(v => {
        if (tbl.cachable) {
          this.cacheService.addEntity(entityName, v);
        }
      })
    )
  }

  private saveAll(entityName: string, objs: any[]): Observable<any> {
    const tbl: TableDef = this.getEntityDef(entityName);
    const url = tbl.url + '/batch/add';
    return this.appRest.post(url, objs);
  }

  /**
   * å é¤å®ä½
   * @param string entityName å®ä½åç§°
   * @param (aseEntity | ID)} obj å®ä½IDæèå®ä½å¯¹è±¡
   * @returns Observable<void>
   * @memberOf AppDao
   */
  remove(entityName: string, obj: BaseEntity | ID,params?: object): Observable<void> {
    const tbl: TableDef = this.getEntityDef(entityName);
    let id: ID = typeof (obj) == 'object' ? obj[tbl.idProp || 'id'] : obj

    return this.appRest.delete(tbl.url, id,params).pipe(
      tap(_ => {
        if (tbl.cachable) {
          this.cacheService.removeEntity(entityName, id)
        }
      })
    )
  }

  /**
   * ä¿å­äºçº§èµæº
   * @param entityName å®ä½åç§°
   * @param subRes å­èµæºï¼å¦role/1,å¯ä»¥æ¯æ½è±¡èµæºï¼å¦å®¡æ ¸ï¼check
   * @param obj å­èµæºå¯¹è±¡
   */
  saveSubEntity(entityName: string, subRes: string, obj?: any): Observable<any> {
    const tbl: TableDef = this.getEntityDef(entityName);
    return this.appRest.post(tbl.url + `/${subRes}`, obj);
  }

  /**
   * å é¤å­èµæº
   * @param entityName å®ä½åç§°
   * @param subRes å­èµæºï¼å¦role/1
   * @param obj å­èµæºå¯¹è±¡
   */
  removeSubEntity(entityName: string, subRes: string, obj: BaseEntity | ID): Observable<void> {
    const tbl: TableDef = this.getEntityDef(entityName);
    let id = obj;
    if (typeof obj === 'object') {
      const idFld = tbl.idProp || 'id';
      id = obj[idFld];
    }
    return this.appRest.delete(`${tbl.url}/${subRes}`, id.toString());
  }

  /**
   * è·åå­èµæºåè¡¨
   * @param entityName å®ä½åç§°
   * @param subRes å­èµæºï¼å¦ 1/role
   */
  getSubEntity(entityName: string, subRes: string): Observable<any> {
    const tbl: TableDef = this.getEntityDef(entityName);
    return this.appRest.get(`${tbl.url}/${subRes}`);
  }
}

export interface FileInfo {
  fileName: string;
  size: number;
  blob: Blob;
}

export interface ApiStatus {
  status: number;
  msg: string;
  data: any;
}

export interface LoginResult {
  orgcode: string;
  user: string;
  token: string;
}
